import React from 'react'
import '../../pages/style.css';
import ProjectCard from "./ProjectCard";
import { Container, Row, Col } from 'react-bootstrap'
import EgyHub from '../../Assets/EgyHub.jpg'
import MemoryGame from '../../Assets/Memory-Game.jpg'
import RoboApp from '../../Assets/Ropot-app.jpg'
import SCPSC from '../../Assets/SCPSC.jpg'
import GithubRepos from '../../Assets/Github-repos.jpg'
import Stvdy from '../../Assets/Stvdy.jpg'

function Projectlist() {
  return (
    <div className="projectbackground">
      <Container fluid className="project-section">
        <Container>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={EgyHub}
                isBlog={false}
                title="Egypt Hub E-commerce"
                description="it's E-commerce website created with React js, redux toolkit, react-router, react bootstrap, REST API."
                ghLink="https://farouk-elmahallawy.github.io/EgyptHub/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={MemoryGame}
                isBlog={false}
                title="Memory-Game"
                description="Memory Card Game The game starts with all the cards face down and players take turns to turn over two cards. If the two cards have the same picture, then cards will not flip again, otherwise the cards flip face down again. The winner is the person with the most cards when all the cards have been taken.
                it was created with React Js
                "
                ghLink="https://farouk-elmahallawy.github.io/memory-game/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={RoboApp}
                isBlog={false}
                title="Robot-App"
                description="This project is a simplified Search app to search for Robots By Name. It was created with React js and Redux"
                ghLink="https://farouk-elmahallawy.github.io/Robot-App/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={SCPSC}
                isBlog={false}
                title="SCPSC website for petroleum company"
                description="SCPSC website is a static webpage built with React Js , react-router. Users can see images of company work and contact information that helps to connect the company through a webpage. webpage builds responsive to multiple sizes of devices."
                ghLink="https://farouk-elmahallawy.github.io/SCPSC/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={GithubRepos}
                isBlog={false}
                title="best-github-repos"
                description="best-github-repos website completely build with react for pagination when user arrive to last repo we do an api call and get more repos it's fully responsive."
                ghLink="https://farouk-elmahallawy.github.io/best-github-repos/"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={Stvdy}
                isBlog={false}
                title="Stvdy"
                description=" Stvdy website is static website completely bulid with html css and javaScript it's responsive."
                ghLink="https://farouk-elmahallawy.github.io/Stvdy/"

              />
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  )
}
export default Projectlist